var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [_vm._v("Impressum")]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("\n            Kontakt:"),
                _c("br"),
                _vm._v("\n            Telefon: + 49 (0) 911 92 86 76 52"),
                _c("br"),
                _vm._v("\n            Telefax: + 49 (0) 911 92 86 76 53"),
                _c("br"),
                _vm._v("\n            E-Mail: Florian@Leuchtenstern.com"),
                _c("br"),
                _vm._v("\n            Website:\n            "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _vm._v("www.dein-idealer-job.de"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p", [_vm._v("Bei redaktionellen Inhalten:")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "text-right font-weight-light" }, [
              _vm._v("JN-32"),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [_vm._v(" ")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Anbieter:"),
      _c("br"),
      _vm._v("\n            aquadrat GbR"),
      _c("br"),
      _vm._v("\n            Pfaffenschlag 10"),
      _c("br"),
      _vm._v("\n            96114 Hirschaid\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Verantwortlich nach § 55 Abs.2 RStV"),
      _c("br"),
      _vm._v("\n            Florian Leuchtenstern"),
      _c("br"),
      _vm._v("\n            Beim Wahlbaum 73"),
      _c("br"),
      _vm._v("\n            90453 Nürnberg\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }